export const FIELD_LIST_TRACKING_WHITELIST = ['is_ig_account_follower', 'tag', 'email']
